import {
  CommunityEventMilestone,
  MilestoneWinner,
} from '../../state/communityJackpot.types';

export const getJackpotWinner = (winners: MilestoneWinner[]) =>
  winners.find(({ winType }) => winType === 'Jackpot');

export const getMilestoneMaker = (winners: MilestoneWinner[]) =>
  winners.find(({ winType }) => winType === 'MilestoneFlip');

export const getOtherPrizes = (winners: MilestoneWinner[]) =>
  winners.filter(({ winType }) => winType === 'Prize');

export const getFlipReward = (milestone?: CommunityEventMilestone) =>
  milestone?.prizes.find(({ rewardType }) => rewardType === 'MilestoneFlip');
